import { useEffect } from 'react'
import {
  handleResetFocus,
  validateForm,
  clickCreateSideEffect,
} from './stateManagement'

export const useSideEffects = (
  sideEffectsRef,
  state,
  props,
  handleSiteChangeCallback,
  handleGradeChangeCallback,
  validateFormCallback,
  updateState,
) => {
  useEffect(() => {
    const sideEffects = sideEffectsRef.current

    // Handle reset focus
    if (sideEffects.handleResetFocus) {
      handleResetFocus(props)
      sideEffects.handleResetFocus = false
    }

    // Handle deleting course created status
    if (sideEffects.deletingCourseCreatedStatus) {
      props.deletingCourseCreatedStatus()
      sideEffects.deletingCourseCreatedStatus = false
    }

    // Handle form validation
    if (sideEffects.validateForm) {
      validateForm(state, props)
        .then(result => {
          updateState(result.newState)
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('[CreateCourse] validateForm failed', error)
        })
      sideEffects.validateForm = false
    }

    // Handle click create side effect
    if (sideEffects.clickCreateSideEffect) {
      clickCreateSideEffect(
        sideEffects.clickCreateSideEffect,
        handleSiteChangeCallback,
      )
      sideEffects.clickCreateSideEffect = null
    }

    // Clear side effects
    sideEffectsRef.current = {}
  }, [
    state,
    props,
    handleSiteChangeCallback,
    handleGradeChangeCallback,
    validateFormCallback,
    updateState,
  ])
}
